var map = {
	"./black/jingyin.png": "7jnP",
	"./blue/jingyin.png": "atml",
	"./white/jingyin.png": "qnGr"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UzKE";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/jingyin\.png$
// module id = UzKE
// module chunks = 24